import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type UseDashboardPhase4Experiment = ModelHookResult<{
	variation: 'control' | 'variant1' | 'variant2';
}>;

export function useDashboardPhase4Experiment(): UseDashboardPhase4Experiment {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardPhase4Experiment: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			variation,
		},
	};
}
